import React, { createContext, useContext, useState, ReactNode } from 'react';

export type Region = 'global' | 'china';

interface RegionContextType {
  currentRegion: Region;
  setCurrentRegion: (region: Region) => void;
}

const RegionContext = createContext<RegionContextType | undefined>(undefined);

interface RegionProviderProps {
  children: ReactNode;
}

export const RegionProvider: React.FC<RegionProviderProps> = ({ children }) => {
  const [currentRegion, setCurrentRegionState] = useState<Region>(() => {
    try {
      const saved = localStorage.getItem('selectedRegion');
      return saved === 'china' ? 'china' : 'global';
    } catch {
      return 'global';
    }
  });

  const setCurrentRegion = (region: Region) => {
    setCurrentRegionState(region);
    localStorage.setItem('selectedRegion', region);
  };

  return <RegionContext.Provider value={{ currentRegion, setCurrentRegion }}>{children}</RegionContext.Provider>;
};

export const useRegion = (): RegionContextType => {
  const context = useContext(RegionContext);
  if (!context) {
    throw new Error('useRegion must be used within a RegionProvider');
  }
  return context;
};
